<template>
  <div
    class="dark-theme-wrapper d-flex align-items-center justify-content-center text-center"
  >
    <div>
      <h1 class="display-1 fw-bold text-red">404</h1>
      <h2 class="text-white mb-4">TUDY CESTA NEVEDE</h2>
      <p class="text-muted mb-4">Hledáš zápas, který se nehraje.</p>
      <router-link to="/" class="btn btn-red-glow"
        >ZPĚT NA HLAVNÍ STRÁNKU</router-link
      >
    </div>
  </div>
</template>

<script>
export default { name: "NotFound" };
</script>
